export class Pet {
    constructor (
        public RentalApplicationKey: number = 0,
        public RentalPetsKey: number = 0,
        public RentalPetTypesKey: number = 0,
        public Breed: string = '',
        public Color: string = '',
        public Weight: number = null,
        public PetName: string = '',
        public IsServiceAnimal: boolean = false,
        public RentalApplicant_RentalApplicantKey:number=0,
        public IsDisabled:boolean=false,
    ) { }
}
